import { render } from "./EmailPopup.vue?vue&type=template&id=735e31ea&scoped=true"
import script from "./EmailPopup.vue?vue&type=script&lang=js"
export * from "./EmailPopup.vue?vue&type=script&lang=js"

import "./EmailPopup.vue?vue&type=style&index=0&id=735e31ea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-735e31ea"]])

export default __exports__